import Logger from "js-logger";
import { tap } from "./utils/helper";

const instanceIds = {};

Logger.setHandler(Logger.createDefaultHandler());

function getLogger(name: string) {
  return tap(Logger.get(name), (l) => l.setLevel(Logger.getLevel()));
}

export function obtainInstanceLogger(name: string) {
  instanceIds[name] = instanceIds[name] || 1;

  return getLogger(`${name}#${instanceIds[name]++}`);
}

export function obtainStaticLogger(name: string) {
  return getLogger(name);
}

export const logger = obtainStaticLogger("VideoPreloader");

Logger.setLevel(Logger.TRACE);
